import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import PopoverText from "../../components/PopoverText";
import QuestionIcon from "../../assets/question-icon.svg";
// import InfoIconGreen from "../../assets/info-icon-green.svg";

import {
  getPlantDetails,
  getSegments,
  getColumnMapping,
  getProceedToAnalysis,
  setState,
  getadvanceSettings,
} from "../../network/cipAPI";
import {
  storeFileId,
  storeApp,
} from "../../Store/TemplateStore/template.action";

import Header from "../../components/Header";
import DupontButton from "../../components/DupontButton";
import PerformanceData from "../performanceData";
import PageLoading from "../../components/PageLoading";
import { OverlayLoader } from "../../components/PageLoading";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";

import { ValueStrings } from "../../utils/constantsString";
import { extractPlantId } from "../../utils/Utils";
import { getItemSession } from "../../utils/session";
import { APPINSIGHTS_STRINGS } from "../../constants/appInsightsStrings";
import { trackEvent } from "../../utils/appInsights";

import ColumnSelection from "./columnSelection";
import ReferenceCondition from "./referenceCondition";
import AdvanceSettings from "./advancedSettings";
import UserAddedCIP from "../../components/AddCIPAndShutdown";
import NormalizationCheck from "./normalizationCheck";
import { API_URLS } from "../../network/appUrls";
import IdentifyCIP from "./identifyCEC";

import "./index.scss";
import MinimumSettings from "./minimumSettings";
import Footer from "../../common/footer";

//const isLocalhost = window.location.hostname === "localhost";
//const basePath = isLocalhost ? "/" : "/roadvisor/";
const basePath = API_URLS.basePath;

const AnalyseData = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const name = getItemSession("name");
  const waterType = getItemSession("water_type");
  const plantPageURL = getItemSession("plantPageURL");

  const data = location.state;
  const token = useSelector((state) => state.token);
  const searchParams = new URLSearchParams(window.location.search);
  const isEdit = searchParams.get("isEdit");

  const userName = useSelector((state) => state.userName);
  const [columnsOption, setColumnsOptions] = useState("");
  const [segmentsOptions, setSegmentsOptions] = useState([]);
  const [fileId, setFileId] = useState("");
  const [mappedColumn, setMappedColumn] = useState([]);
  const [config, setConfig] = useState([]);
  const [mappedReference, setMappedReference] = useState([]);
  const [datasetDetails, setDatasetDetails] = useState("");
  const [fileInfo, setFileInfo] = useState([]);
  const [min_date, setMinDate] = useState("");
  const [max_date, setMaxDate] = useState("");
  const [view, setView] = useState(null);
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false);
  const [isNormalizationColumnFilled, setIsNormalizationColumnFilled] =
    useState(false);
  const [isNormalizationPopUpOpen, setIsNormalizationPopUpOpen] =
    useState(false);
  const [isDataCleaningDialogOpen, setIsDataCleaningDialogOpen] =
    useState(false);
  const [isIdentifiedCECS, setIdentifiedCECS] = useState(false);
  const [cecWarningMessage, setCecWarningMessage] = useState("");
  const [plantName, setPlantName] = useState(name);
  const [water_type, setWater_type] = useState(waterType);
  const [isReferenceEnabled, setisReferenceEnabled] = useState(false);
  const [isProceedEnabled, setIsProceedEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [addCecButtonDisable, setAddCecButtonDisable] = useState(true);
  const [selectedColumnRadioColumn, setSelectedColumnRadioColumn] = useState({
    // ["column5"]: "feed_flowrate",
    ["column8"]: "tmp_drop",
  });
  const [selectedCheckColumn, setSelectedCheckColumn] = useState({
    ["column88"]: ["filtrate_flowrate"],
  });
  const plantId = extractPlantId();
  const [hasMinimumSettingsError, setHasMinimumSettingsError] = useState(false);
  const [hasReferenceError, setHasReferenceError] = useState(false);

  const handleSettingsDialogOpen = () => {
    setIsSettingsDialogOpen(true);
  };
  const handleSettingsDialogClose = () => {
    setIsSettingsDialogOpen(false);
  };

  const getFormattedDate = (dateString) => {
    const date = moment(dateString).isValid();
    return date ? moment(dateString).format(ValueStrings.dateFormat) : "";
  };

  const handleFileRemoval = () => {
    setFileId("");
    setFileInfo([]);
    setColumnsOptions("");
    setSegmentsOptions([]);
    setMappedColumn([]);
    setMappedReference([]);
    setIsNormalizationColumnFilled(false);
    setIsProceedEnabled(true);
    setAddCecButtonDisable(true);
  };

  useEffect(() => {
    const isFileIdEmpty =
      !fileId || fileId === "" || fileId === null || fileId === undefined;

    if (isFileIdEmpty) {
      setIsProceedEnabled(true);
      setIsNormalizationColumnFilled(false);
      return;
    }

    const shouldDisable = !isNormalizationColumnFilled;
    setIsProceedEnabled(shouldDisable);
  }, [fileId, isNormalizationColumnFilled]);

  useEffect(() => {
    const isFileIdEmpty =
      !fileId || fileId === "" || fileId === null || fileId === undefined;
    if (isFileIdEmpty) {
      setTimeout(() => {
        setIsProceedEnabled(true);
      }, 0);
    }
  }, [fileId]);

  const safeSetIsProceedEnabled = (value) => {
    const isFileIdEmpty =
      !fileId || fileId === "" || fileId === null || fileId === undefined;
    if (isFileIdEmpty && !value) {
      return;
    }
    setIsProceedEnabled(value);
  };

  useEffect(() => {
    const getPlantDetail = async () => {
      setIsLoading(true);
      try {
        const response = await getPlantDetails(true);
        if (response && response.data) {
          const responseData = response.data;
          setView(responseData.view);
          const fileInfo = {
            file_id: responseData?.file?.file_id,
            fileName: responseData?.file?.file_name,
            min_date: responseData?.file?.min_date,
            max_date: responseData?.file?.max_date,
            cip_source: responseData?.cip_source || "",
          };
          dispatch(storeFileId(fileInfo));
          setFileInfo(fileInfo);
          setFileId(responseData?.file?.file_id);
          setMappedColumn(responseData?.col_mapping);
          setConfig(responseData?.config);
          setMappedReference(responseData?.ref_condition);
          setDatasetDetails(
            ` ${userName}_ ${responseData.name}_ ${responseData?.water_type}
            ${
              getFormattedDate(response?.file?.min_date)
                ? `_ ${getFormattedDate(responseData?.file?.min_date)}`
                : ""
            }
            ${
              getFormattedDate(responseData?.file?.max_date)
                ? `to ${getFormattedDate(responseData?.file?.max_date)}`
                : ""
            }`
          );

          if (fileInfo.file_id) {
            const columns = await getColumnMapping(fileInfo.file_id);
            if (columns && columns.data) {
              setColumnsOptions(columns.data?.cols);
              const segmentresposnse = await getSegments();
              const segments = segmentresposnse.data.segments;
              if (segmentresposnse) {
                setAddCecButtonDisable(false);
              }
              setMinDate(segmentresposnse.data.min_date);
              setMaxDate(segmentresposnse.data.max_date);
              if (Array.isArray(segments) && segments.length > 0) {
                const segmentarray = [];
                segments.forEach((segment) => {
                  segmentarray.push(
                    `${segment.start_date} - ${segment.end_date}`
                  );
                });
                setSegmentsOptions(segmentarray);
              }
            }
          }
        }
      } catch (err) {
        console.log("getPlantDetail..", err);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
    dispatch(storeApp(null));
    if (token) getPlantDetail();
  }, [token]);

  useEffect(() => {
    const fetchAdvancedSettings = async () => {
      if (!token) return;

      try {
        const settingsResponse = await getadvanceSettings();
        if (settingsResponse && settingsResponse.data) {
          dispatch({
            type: "STORE_SETTINGS_DEFAULTS",
            payload: {
              optimization_target:
                settingsResponse.data.optimization_target ||
                "Minimize Total Cost",
            },
          });
        }
      } catch (error) {
        console.log("Error fetching optimization_target: ", error);
      }
    };

    fetchAdvancedSettings();
  }, [token]);

  useEffect(() => {
    if (!fileId) {
      setDatasetDetails(` ${userName}_ ${name}_ ${water_type}`);
    }
  }, [fileId]);

  const onExitClick = async () => {
    try {
      const response = await setState(2);
      if (plantPageURL) {
        navigate(plantPageURL);
      } else navigate(`${basePath}plant`);
    } catch (error) {
      console.log("onExitClick", error);
    }
  };

  const onProceedClick = async () => {
    setIsLoading(true);
    try {
      trackEvent(APPINSIGHTS_STRINGS.PROCEED_TO_ANALYSIS_CLICKED, {
        plantName: plantName,
        plantId: plantId,
        fileId: fileId
      });
      
      if (isNormalizationColumnFilled) {
        const response = await getProceedToAnalysis(fileId);
        if (response && response.status === 200) {
          const path = `${basePath}home?plantId=${plantId}`;
          navigate(path);
        } else {
          createNotification(
            ERROR_NOTIFICATION,
            response.data.detail.error,
            ""
          );
        }
      } else {
        setIsNormalizationPopUpOpen(true);
      }
    } catch (error) {
      createNotification(
        ERROR_NOTIFICATION,
        t("notificationStrings.somethingWrong"),
        ""
      );
      console.log("onProceedClick", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Enable Proceed to Analysis if isEdit is true
  const isProceedButtonDisabled =
    (isProceedEnabled && !isEdit) ||
    hasMinimumSettingsError ||
    hasReferenceError;

  return (
    <div className="container-main">
      <Header />

      <div className="main-container ">
        <div className="content-container descriptionText font-14">
          {isLoading && <OverlayLoader />}
          {/* <div className="calculatedValueText">{t("analyseData.selectData")}</div> */}
          <div>
            <PerformanceData
              setColumnsOptions={setColumnsOptions}
              setSegmentsOptions={setSegmentsOptions}
              setFileId={setFileId}
              fileId={fileId}
              fileInfo={fileInfo}
              setDatasetDetails={setDatasetDetails}
              plantName={plantName}
              water_type={water_type}
              setMinDate={setMinDate}
              setMaxDate={setMaxDate}
              setView={setView}
              setAddCecButtonDisable={setAddCecButtonDisable}
              onFileRemoval={handleFileRemoval}
            />
          </div>
          <div className="flex-ai-center container-padding">
            <span className="tealText">{t("analyseData.datasetName")} </span>
            &nbsp;
            {datasetDetails}
          </div>

          <div className="marginTop5 ">
            <ColumnSelection
              columnsOption={columnsOption}
              setColumnsOptions={setColumnsOptions}
              segmentsOptions={segmentsOptions}
              setSegmentsOptions={setSegmentsOptions}
              fileId={fileId}
              isEdit={isEdit}
              mappedColumn={mappedColumn}
              mappedReference={mappedReference}
              setDatasetDetails={setDatasetDetails}
              plantName={plantName}
              water_type={water_type}
              selectedRadioColumn={selectedColumnRadioColumn}
              setSelectedRadioColumn={setSelectedColumnRadioColumn}
              setMappedReference={setMappedReference}
              setIsProceedEnabled={safeSetIsProceedEnabled}
              setIsNormalizationColumnFilled={setIsNormalizationColumnFilled}
              config={config}
              selectedCheckColumn={selectedCheckColumn}
              setSelectedCheckColumn={setSelectedCheckColumn}
              setView={setView}
            />
          </div>
          <div className="margin-top-20 ">
            <ReferenceCondition
              fileId={fileId}
              isEdit={isEdit}
              mappedReference={mappedReference}
              selectedColumnRadioColumn={selectedColumnRadioColumn}
              setisReferenceEnabled={setisReferenceEnabled}
              setIsProceedEnabled={safeSetIsProceedEnabled}
              selectedCheckColumn={selectedCheckColumn}
              setSelectedCheckColumn={setSelectedCheckColumn}
              setView={setView}
              setHasReferenceError={setHasReferenceError}
            />
          </div>
          <div className="margin-top-20 ">
            <MinimumSettings
              fileId={fileId}
              isEdit={isEdit}
              setView={setView}
              setIsProceedEnabled={setIsProceedEnabled}
              setHasMinimumSettingsError={setHasMinimumSettingsError}
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <UserAddedCIP
              fileInfo={fileInfo}
              max_date={max_date}
              min_date={min_date}
              fileId={fileId}
              setView={setView}
              addCecButtonDisable={addCecButtonDisable}
            />
          </div>

          <div className="margin-top-20 flex-between ">
            <DupontButton
              customClass="margin-left-10"
              onClick={handleSettingsDialogOpen}
            >
              {t("analyseData.settings")}
            </DupontButton>

            <div>
              <div className="inline-flex-container">
                <PopoverText
                  descriptor={<img src={QuestionIcon} alt="question icon" />}
                  descriptionText={t(
                    "analyseData.proceedToAnalysisTroubleshooting"
                  )}
                />
                <DupontButton
                  onClick={onExitClick}
                  customClass="margin-right-20"
                >
                  {" "}
                  {t("ValueStrings.exit")}
                </DupontButton>
              </div>
              <DupontButton
                disabled={isProceedButtonDisabled}
                onClick={onProceedClick}
              >
                {" "}
                {t("analyseData.proceedtoAnalysis")}
              </DupontButton>
            </div>
          </div>
        </div>
        {(isNormalizationPopUpOpen || isDataCleaningDialogOpen) && (
          <NormalizationCheck
            fileId={fileId}
            view={view}
            isNormalizationPopUpOpen={isNormalizationPopUpOpen}
            setIsNormalizationPopUpOpen={setIsNormalizationPopUpOpen}
            isDataCleaningDialogOpen={isDataCleaningDialogOpen}
            setIsDataCleaningDialogOpen={setIsDataCleaningDialogOpen}
            setIdentifiedCECS={setIdentifiedCECS}
            setCecWarningMessage={setCecWarningMessage}
          />
        )}

        {isIdentifiedCECS && (
          <IdentifyCIP
            fileId={fileId}
            plantId={plantId}
            max_date={max_date}
            min_date={min_date}
            fileInfo={fileInfo}
            isIdentifiedCECS={isIdentifiedCECS}
            setIdentifiedCECS={setIdentifiedCECS}
            cecWarningMessage={cecWarningMessage}
            setCecWarningMessage={setCecWarningMessage}
          />
        )}

        <AdvanceSettings
          isSettingsDialogOpen={isSettingsDialogOpen}
          handleSettingsDialogClose={handleSettingsDialogClose}
          setView={setView}
        />
        <Footer />
      </div>
    </div>
  );
};
export default AnalyseData;
